import LegalDocumentPage from "./LegalDocumentPage";
import { siteMapDocument } from "./legalDocumentContent";

const SiteMapPage = () => {
  return <LegalDocumentPage document={siteMapDocument} />;
};

export default SiteMapPage;